export default {
  isFileUploading: false,

  isTagsLoading: false,
  boundTags: {},
  tags: [],
};
